"use client";

import React from "react";
import ProofOfTravel from "./ProofOfTravel";
import "./styles.scss";

interface ServiceCardProps {
  name: string;
  title: string;
  time: string | null;
  price: number | null;
  selected: boolean;
  handleChange: (method: string) => void;
  defaultChecked?: boolean;
}

const ServiceCard = ({
  name,
  title,
  time,
  price,
  selected,
  handleChange,
  defaultChecked,
}: ServiceCardProps) => {
  return (
    <div className="Services__card-container">
      <label
        key={name}
        htmlFor={name}
        className={`Services__options-radio-card ${selected ? "Services__options-radio-card--selected" : ""}`}>
        <input
          type="radio"
          id={name}
          name="service-option"
          value={name}
          defaultChecked={defaultChecked}
          onChange={() => handleChange(name)}
          data-qa={`choose-service-${name}`}
        />
        <div className="Services__options-card-content">
          <div className="Services__options-header">
            <div className="Services__options-radio-circle"></div>
            <h3 className="Services__options-title">{title}</h3>
          </div>
          <div className="Services__options-price-section">
            {time && <span className="Services__options-time">{time}</span>}
            {price && <span className="Services__options-price">{`$${price}`}</span>}
          </div>
        </div>
      </label>
      {/* Show ProofOfTravelField only if the card is selected and NOT "form" */}
      {selected && name !== "form" && <ProofOfTravel serviceName={name} />}
    </div>
  );
};

export default ServiceCard;
